module.exports = __webpack_public_path__ + "static/media/exportIcon.9d158358.svg";